enum END_OF_TENANCY {
  INPUT_METERS = "endOfTenancyMetersInput",
  GET_QUOTE = "endOfTenancyGetQuote",
  WITH_WARRANTY = "endOfTenancyWithWarrantyButton",
  WITHOUT_WARRANTY = "endOfTenancyWithoutWarrantyButton",
  CALENDAR_WRAPPER = "endOfTenancyCalendarWrapper",
}

enum END_OF_TENANCY_QUOTE_MESSAGES {
  ERROR = "endOfTenancyQuoteError",
  ALL_EXTRAS = "endOfTenancyQuoteAllExtras",
  BIG_SURFACE = "endOfTenancyQuoteBigSurface",
}

enum END_OF_TENANCY_EXTRAS {
  INSIDE_FRIDGE = "endOfTenancyInsideFridgeExtra",
  INSIDE_OVEN = "endOfTenancyInsideOvenExtra",
  DOOR_HANDLES = "endOfTenancyDoorHandlesExtra",
  BASEBOARDS = "endOfTenancyBaseBoardsExtra",
  INTERIOR_WINDOWS = "endOfTenancyInteriorWindowsExtra",
  INSIDE_CABINETS = "endOfTenancyInsideCabinetsExtra",
  WINDOW_BLINDS = "endOfTenancyWindowBlindsExtra",
  BALCONY = "endOfTenancyBalconyExtra",
}

enum END_OF_TENANCY_SUMMARY_EXTRAS {
  INSIDE_FRIDGE = "endOfTenancySummaryInsideFridgeExtra",
  INSIDE_OVEN = "endOfTenancySummaryInsideOvenExtra",
  DOOR_HANDLES = "endOfTenancySummaryDoorHandlesExtra",
  BASEBOARDS = "endOfTenancySummaryBaseBoardsExtra",
  INTERIOR_WINDOWS = "endOfTenancySummaryInteriorWIndowsExtra",
  INSIDE_CABINETS = "endOfTenancySummaryInsideCabinetsExtra",
  WINDOW_BLINDS = "endOfTenancySummaryWindowBlindsExtra",
  BALCONY = "endOfTenancySummaryBalconyExtra",
}

enum END_OF_TENANCY_SUMMARY {
  PRICE = "endOfTenancySummaryPrice",
}

enum END_OF_TENANCY_OFFER_CALC {
  STANDARD_CLEANING = "endOfTenancyOfferStandardCleaning",
  EXTRAS = "endOfTenancyOfferExtras",
  TOTAL = "endOfTenancyOfferTotal",
}

export {
  END_OF_TENANCY,
  END_OF_TENANCY_QUOTE_MESSAGES,
  END_OF_TENANCY_EXTRAS,
  END_OF_TENANCY_SUMMARY_EXTRAS,
  END_OF_TENANCY_SUMMARY,
  END_OF_TENANCY_OFFER_CALC,
};
